import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

type Props = { text: string; onSave: (text: string) => void; onCancel: () => void };

/** The message as Markdown, as the analyst will send it; the preview returns once they save. */
export function MessageEditor({ text, onSave, onCancel }: Props) {
  const [draft, setDraft] = useState(text);
  return (
    <Stack component="section" aria-labelledby="message-edit" sx={{ gap: 1 }}>
      <Typography id="message-edit" variant="caption" component="h3" sx={{ fontWeight: 600 }}>Message</Typography>
      <TextField
        multiline
        minRows={5}
        maxRows={16}
        value={draft}
        onChange={(e) => { setDraft(e.target.value); }}
        slotProps={{ htmlInput: { 'aria-label': 'Message text' } }}
        sx={{ '& textarea': { fontSize: '0.875rem', lineHeight: 1.6 } }}
      />
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        Use **text** for bold and &quot;- &quot; for bullets. The disclaimer is added on send and cannot be removed.
      </Typography>
      <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 1 }}>
        <Button variant="outlined" onClick={onCancel} sx={{ color: 'text.primary', borderColor: 'divider' }}>Cancel</Button>
        <Button variant="contained" disabled={!draft.trim()} onClick={() => { onSave(draft.trim()); }}>Save changes</Button>
      </Stack>
    </Stack>
  );
}
